export default "__VITE_ASSET__35dc708e__"